import React from 'react';
import { Button } from 'reactstrap';
import Buttons from '../../_components/common/Button';
import Footer from '../../_components/common/Footer';
import NavBar from '../../_components/common/Navbar';
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import './index.css';
import ModalNew from '../../_components/common/ModalNew';
import { createProfileAction, BulkDownloadActions } from '../../_actions';
import { withRouter } from 'react-router-dom';

class Admin extends React.Component {

    state = {
        role: 'sellerAdmin',
        createProfileState: true,


        bulkDownloadPermission: false,

        loadBulkReport: false


    }

    componentDidMount() {

        const { dispatch, history } = this.props;

        const userType = localStorage.getItem('usertype');

        if (userType.split(',').includes('organisation_admin')) {
            const orgId = localStorage.getItem('orgId');
            dispatch(BulkDownloadActions.checkBulkDownloadPermissions({ "org_id": orgId }, (callbackData) => {
                if (callbackData.data) {
                    this.setState({
                        bulkDownloadPermission: callbackData.data.bulk_download_permission_given
                    })
                }
            }))
        }

        history.push('/admin/app/dashboard');
        window.onpopstate = () => {
            history.push('/admin/app/dashboard');
        };

    }

    componentWillUnmount() {
        window.onpopstate = null;
    }






    toggleEntireCreateProfileModal = (showModal) => {
        this.setState({
            createProfileState: showModal
        })
    }

    actionSelected(data) {

        const fd = data.sellerData;

        const formData = {
            'full_name': fd.Name,

            'short_name': fd.Short_name
        }
        localStorage.setItem('user_name', fd.Short_name)

        this.props.dispatch(createProfileAction.createProfileHandler(formData))
        this.props.dispatch(createProfileAction.isSignUpCompleted('true'))
    }

    downloadBulkReport = () => {
        const { dispatch } = this.props;

        const orgId = localStorage.getItem('orgId');


        this.setState({
            loadBulkReport: true
        }, () => {
            dispatch(BulkDownloadActions.downloadBulkReport({ "organisation_id": +orgId }, (callback_data) => {
                this.setState({
                    loadBulkReport: false
                }, () => {
                    if (callback_data.data) {
                        if (callback_data.data.response) {
                            Swal({
                                title: callback_data.data.response,
                                type: 'info',
                                showCancelButton: false,
                                confirmButtonText: 'OK'
                            })
                        }
                    }
                })
            }))
        })
    }

    render() {
        const short_name = localStorage.getItem('short_name');
        const full_name = localStorage.getItem('full_name');
        const { isSignUpCompletedResponse } = this.props;
        const role = localStorage.getItem('usertype');
        const orgId = localStorage.getItem('orgId');
        const is_primary_admin = localStorage.getItem('is_primary_admin');


        isSignUpCompletedResponse === '' ? this.props.dispatch(createProfileAction.isSignUpCompleted(localStorage.getItem('is_sign_up_completed'))) : isSignUpCompletedResponse


        const formData = [{
            key: 'Name',
            type: 'text',
            value: full_name === '' || full_name === 'null' ? '' : full_name,
            valid: full_name === '' || full_name === 'null' ? false : true,
            regex: "^[a-zA-Z]+[a-zA-Z ]+$",

            elementConfig: {
                name: 'Name',
                label: 'Name',
                placeholder: 'Your Name'
            },
            validation: {
                required: true,
                message: "is required"
            },

        }, {
            key: 'Short_name',
            type: 'text',
            value: short_name === '' || short_name === 'null' ? '' : short_name,
            valid: short_name === '' || short_name === 'null' ? false : true,
            regex: "^[a-zA-Z]*[a-zA-Z ]+$",
            elementConfig: {
                name: 'Short_name',
                label: 'Short Name',
                placeholder: 'Your Short name'
            },
            validation: {
                required: true,
                message: "is required"

            },
        },

        ]
        const userType = localStorage.getItem('usertype');
        const isAdmin = userType.includes('super_admin') || userType.includes('seller_admin') || userType.includes('organisation_admin')
        const showFooter = !userType.includes('seller_admin') && !userType.includes('organisation_admin');


        return (
            <div>
                <div className="position-relative  custom-container-footer animation-fade-in">

                    <div>
                        <NavBar />
                    </div>
                    {
                        isSignUpCompletedResponse === 'false' && !isAdmin &&
                        <ModalNew
                            hideClose={true}
                            selectKey={['id']}
                            selects={['gender']}
                            modalName="createProfile"
                            heading="CREATE PROFILE"
                            showModal={this.state.createProfileState}
                            formData={formData}
                            action={this.actionSelected.bind(this)}
                            toggleEntireModal={this.toggleEntireCreateProfileModal.bind(this)}
                        />
                    }




                    {
                        isSignUpCompletedResponse === 'true' &&
                        < div className="container ">
                            <div>
                                <div className="bg-green rounded-top position-relative mt-5">
                                    <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> ADMINISTRATOR ACTIONS  </p>
                                </div>
                            </div>
                            <div className="mx-md-4 mx-0">
                                <div className="d-flex flex-row flex-wrap justify-content-start mt-4 pb-5">
                                    {
                                        role.includes('super_admin') &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="SELLERS" link="admin/app/sellers" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin') || role.includes('seller_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="ORGANISATIONS" link="admin/app/organisation" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="CSV DOWNLOADS" link="admin/app/csv-downloads" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin') || role.includes('seller_admin') || role.includes('organisation_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="ASSESSMENT SUMMARY" link="admin/app/assessment-summary" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="CUSTOM EMAILS" link="admin/app/custom-emails" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="REPORT CONTENT" link="admin/app/edit-report" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="RELATION GROUPS" link="admin/app/relation-groups" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="DEVELOPMENT PLAN" link="admin/app/development-plan" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="DEMOGRAPHIC MASTERS" link="admin/app/demographic-masters" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('super_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="UPLOAD- DEMOGRAPHIC DATA" link="admin/upload-demographic-data" type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('organisation_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="MANAGE BATCHES" link={"admin/app/organisation/" + orgId + "/manageBatches"} type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('organisation_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="MANAGE PARTICIPANTS" link={"admin/app/organisation/" + orgId + "/manageParticipants"} type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('organisation_admin') || role.includes('seller_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="ALLOTMENT SUMMARY" link={"admin/app/allotment-summary"} type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('organisation_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="UPLOAD ASSESSMENTS" link={"admin/app/organisation/" + orgId + "/uploadAssessment"} type="btn-block" />
                                        </div>
                                    }
                                    {
                                        (role.includes('organisation_admin')) &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="UPLOAD ASSESSMENTS RESPONSES" link={"admin/app/organisation/" + orgId + "/uploadAssessmentResponse"} type="btn-block" />
                                        </div>
                                    }

                                    {
                                        ((role.includes('organisation_admin')) && is_primary_admin === 'true') &&
                                        <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                            <Buttons name="MANAGE BATCH PERMISSIONS" link={"admin/app/organisation/" + orgId + "/manageBatchPermissions"} type="btn-block" />
                                        </div>
                                    }

                                    {
                                        this.state.bulkDownloadPermission ?
                                            <div className="col-12 col-md-6 col-lg-4 py-3 px-4" >
                                                <Button disabled={this.state.loadBulkReport} onClick={() => this.downloadBulkReport()} className="btn btn-danger buttonColor buttonFont text-white customBorderRadius quattrocentosans regular btn-block" type="btn-block">
                                                    {this.state.loadBulkReport ? <i className="fa fa-spinner fa-spin"></i> : 'DOWNLOAD BULK REPORT'}
                                                </Button>
                                            </div>
                                            :
                                            null
                                    }

                                </div>
                            </div>
                        </div>

                    }

                </div>
                {showFooter && (
                    <div>
                        <footer className="custom-footer">
                            <Footer />
                        </footer>
                    </div>
                )}

            </div >
        );
    }
}

function mapStateToProps(state) {

    const { isSignUpCompletedLoading } = state.isSignUpCompletedReducer;
    const isSignUpCompletedResponse = (!isSignUpCompletedLoading) ? state.isSignUpCompletedReducer.data : '';
    return {
        isSignUpCompletedLoading,
        isSignUpCompletedResponse,
    };
}

export default withRouter(connect(mapStateToProps)(Admin));




// WEBPACK FOOTER //
// ./src/_pages/Admin/index.jsx